import { useState, useEffect } from 'react';

function useControlledTextValue(value, onChange) {
    const [textValue, setTextValue] = useState(value);
    useEffect(() => {
        setTextValue(value);
    }, [value]);
    const handleChange = (e) => {
        setTextValue(e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    const isEmpty = !textValue && !value;
    const hasValue = !!(textValue || value);
    return { textValue, handleChange, isEmpty, hasValue };
}

export { useControlledTextValue };
